import React from "react";
import { useFrame } from "@react-three/fiber";
import { Group } from "three";
import * as THREE from "three";

const pos = new THREE.Vector3();
const dir = new THREE.Vector3();

function LoadingText() {
  const spinner = React.useRef<THREE.Mesh | null>(null);
  const groupref = React.useRef<Group>(null);

  useFrame((state) => {
    state.camera.getWorldPosition(pos);
    state.camera.getWorldDirection(dir);

    if (groupref.current) {
      groupref.current.position.copy(dir.multiplyScalar(2.5).add(pos));
      groupref.current.lookAt(pos);
    }
    groupref.current?.rotation.copy(state.camera.rotation);

    if (spinner.current) {
      spinner.current.rotation.z -= 0.2;
    }
  });

  return (
    <group ref={groupref}>
      <mesh renderOrder={6} position={[0, 0, 0]} ref={spinner}>
        <ringGeometry args={[0.06, 0.075, 4, 1, 0, Math.PI / 1.5]} />
      </mesh>
      <mesh>
        <ringGeometry args={[0.06, 0.07, 16]} />
        <meshBasicMaterial transparent depthTest={false} opacity={0.3} />
      </mesh>
    </group>
  );
}

export default LoadingText;
